import * as yup from 'yup'
import { I18n } from 'react-redux-i18n'

const schema = yup
  .object()
  .shape({
    given_name: yup.string().required(I18n.t('RequiredGivenName')),
    family_name: yup.string().required(I18n.t('RequiredFamilyName')),
    password: yup
      .string()
      .required(I18n.t('RequiredPassword'))
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{6,}$/,
        I18n.t('RequiredStrongPassword')
      ),
  })
  .required()
  .noUnknown()

export default schema
